import { render, staticRenderFns } from "./SoftVersionIcon.vue?vue&type=template&id=3948a11c&scoped=true&"
import script from "./SoftVersionIcon.vue?vue&type=script&lang=ts&setup=true&"
export * from "./SoftVersionIcon.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./SoftVersionIcon.vue?vue&type=style&index=0&id=3948a11c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3948a11c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3948a11c')) {
      api.createRecord('3948a11c', component.options)
    } else {
      api.reload('3948a11c', component.options)
    }
    module.hot.accept("./SoftVersionIcon.vue?vue&type=template&id=3948a11c&scoped=true&", function () {
      api.rerender('3948a11c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/SoftVersionIcon/SoftVersionIcon.vue"
export default component.exports